import { t } from "@lingui/macro";
import { Star } from "@phosphor-icons/react";
import { motion } from "framer-motion";

type Testimonial = {
  quote: string;
  author: string;
  role: string;
};

const testimonials = (): Testimonial[] => [
  {
    quote: t`I could turn around and apply to a job within an hour. Keyword targeting after a layoff made all the difference.`,
    author: "Todd",
    role: t`Senior product marketing manager`,
  },
  {
    quote: t`It helped me get through the ATS system and get noticed by recruiters. The score showed exactly what to fix.`,
    author: "Bala",
    role: t`IT systems operations manager`,
  },
  {
    quote: t`The manual labor is gone so I can focus on interviews. Landed my internship using job-matching AI.`,
    author: "Rahul",
    role: t`Product design student`,
  },
];

export const SocialProofSection = () => {
  const items = testimonials();

  return (
    <section id="social-proof" className="relative bg-[#050505] py-24 sm:py-32">
      <div className="container mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mx-auto mb-16 max-w-2xl text-center"
        >
          <div className="mb-6 flex justify-center">
            <span className="rounded-full bg-white/5 border border-white/10 px-4 py-1.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-white/80 shadow-[inset_0_1px_1px_rgba(255,255,255,0.1)] backdrop-blur-md">
              {t`Social Proof`}
            </span>
          </div>
          <h2 className="font-sans text-3xl font-bold tracking-tighter text-white sm:text-4xl md:text-5xl">
            {t`Trusted by job seekers worldwide`}
          </h2>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-3">
          {items.map((item, index) => (
            <motion.blockquote
              key={item.author}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: index * 0.08 }}
              className="relative flex h-full flex-col rounded-[2rem] border border-white/10 bg-[#0a0a0a] p-8 shadow-2xl overflow-hidden"
            >
              {/* Subtle inner highlight */}
              <div className="absolute inset-0 rounded-[2rem] shadow-[inset_0_1px_1px_rgba(255,255,255,0.05)] pointer-events-none" />
              
              <div className="mb-6 flex gap-1 text-emerald-400">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} weight="fill" className="size-4" />
                ))}
              </div>
              <p className="flex-1 text-[15px] leading-relaxed text-white/70 font-light">
                &ldquo;{item.quote}&rdquo;
              </p>
              <footer className="mt-8 border-t border-white/10 pt-6">
                <cite className="not-italic flex flex-col gap-1">
                  <div className="font-semibold text-white/90">{item.author}</div>
                  <div className="text-[11px] uppercase tracking-wider font-medium text-white/40">{item.role}</div>
                </cite>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
